import { IBitTarget, IBitTargetExecutor, IEntity } from "../../types";

// target selectors
const self = (actors: IEntity[], sourceIndex: number) => sourceIndex;
const foe = (actors: IEntity[], sourceIndex: number) =>
  actors.findIndex((_, index) => index !== sourceIndex);

export const targets: IBitTargetExecutor = { self, foe };

export const select = (
  actors: IEntity[],
  sourceIndex: number,
  payload: IBitTarget
): number => {
  // target selectors use Array.prototype.findIndex
  if (!payload) return -1;
  return targets[payload.key](actors, sourceIndex);
};
